<template>
  <div>
    <admin-offer-expandable-panel />
    <order-details-for-order-item :data="data" v-if="data !== null">
      <v-tooltip bottom>
        {{ $t("travelService.goToOrder") }}
        <template #activator="{on}">
          <v-btn :to="'/admin/travel-service/edit/' + data.id" class="mx-0" icon v-on="on" small>
            <v-icon small>fa-file-invoice</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </order-details-for-order-item>

    <order-item-parameters :type="type" :order-item="data.orderItem" />

    <v-row class="mb-2">
      <v-col cols="10">
        <v-alert color="error darken-4" outlined>
          Jeśli z jakiegoś powodu oferta przestała być aktualna lub wymagane są dodatkowe dane od klienta niezbędne do rezerwacji możesz zadać dodatkowe pytanie
          zamawiającemu. Aby to zrobić kliknij ikonę wiadomości po prawej stronie.
          <span class="font-weight-bold">
            Funkcjonalność ta powinna być wykorzystywana jedynie w przypadku gdy nie da się zarezerwować przedstawionej oferty.
          </span>
        </v-alert>
      </v-col>
      <v-col cols="2" class="pa-4" style="text-align: center;">
        <a @click="isMessagesEnabled = true">
          <v-icon size="80">email</v-icon>
        </a>
      </v-col>
    </v-row>

    <message-list
      class="mb-3"
      v-if="isMessagesEnabled || data.messages.length > 0"
      :travel-service-order-id="data.id"
      :travel-service-order-item-id="data.orderItem.id"
      :start-messages="data.messages"
    />

    <h2>Wybrana oferta</h2>

    <v-form ref="form" v-model="isValid">
      <offer-item-form :service-offer.sync="serviceOffer" :is-baggage-field-required="isBaggageFieldRequired" :type="type">
        <amount-input
          :model.sync="serviceOffer.price"
          :rules="[isRequired]"
          label="Cena łącznie*"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
        <currency-select
          :model.sync="serviceOffer.currency"
          :rules="[isRequired]"
          label="Waluta*"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
        <ajax-file
          :assign_id="serviceOffer.id"
          :items.sync="serviceOffer.files"
          assign_shortcut="travelServiceOrderItemResponseOptions"
          :outlined="true"
          background-color="blue lighten-5"
        />
      </offer-item-form>
    </v-form>
    <v-alert
      :value="true"
      outlined
      color="error darken-3"
      v-if="serviceOffer.travel_service_offer_changes_behavior === changeAcceptanceType.INFORM_AFTER_CHANGE && !$store.state.AdminTravelService.isOfferReadonly"
    >
      Ten klient <b>będzie informowany o każdej zmianie</b> w ofercie po jej zapisaniu i wysłaniu. Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne.
      Będziesz mógł jedynie załączyć plik z rezerwacją.
    </v-alert>
    <v-alert
      :value="true"
      outlined
      color="error darken-3"
      v-if="serviceOffer.travel_service_offer_changes_behavior === changeAcceptanceType.ACCEPTANCE_NEEDED && !$store.state.AdminTravelService.isOfferReadonly"
    >
      Każda zmiana w ofercie po wybraniu przez tego klienta <b>musi być ponownie akceptowana</b>. Włączyłeś tryb edycji - oferta trafi ponownie do akceptacji.
      Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne. Będziesz mógł jedynie załączyć plik z rezerwacją.
    </v-alert>
    <v-card text flat>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancel" color="blue darken-1" text>Anuluj</v-btn>
        <v-btn v-if="$store.state.AdminTravelService.isOfferReadonly" :disabled="$store.getters['Ajax/loading']" @click="unlockEdit" color="blue darken-1" text>
          Odblokuj edycję
        </v-btn>
        <v-btn :disabled="$store.getters['Ajax/loading']" @click="previewPDF" color="blue darken-1" text>Podgląd PDF</v-btn>
        <v-btn :disabled="$store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>Zapisz i wyślij </v-btn>
      </v-card-actions>
    </v-card>

    <AdminOfferHistory :service-offer="[serviceOffer]" />
  </div>
</template>

<script>
import AjaxFile from "../../../components/CustomInputComponents/AjaxFile";
import AdminOfferHistory from "../../../components/TravelService/AdminOfferHistory";
import OfferItemForm from "../../../components/TravelService/Admin/OfferItemForm/OfferItemForm";
import downloadFile from "../../../repository/downloadFile";
import OrderItemParameters from "../../../components/TravelService/Admin/OrderItemParameters";
import OrderDetailsForOrderItem from "../../../components/TravelService/OrderDetailsForOrderItem";
import MessageList from "../../../components/MessageList";
import AmountInput from "../../../components/CustomInputComponents/AmountInput";
import CurrencySelect from "../../../components/CustomInputComponents/CurrencySelect";
import { changeAcceptanceType } from "../../../staticData/TravelServiceTypes";
import AdminOfferExpandablePanel from "../../../components/TravelService/Admin/AdminOfferExpandablePanel";

export default {
  name: "AdminTravelServiceAddBookingView",
  components: {
    AdminOfferExpandablePanel,
    CurrencySelect,
    AmountInput,
    MessageList,
    OrderDetailsForOrderItem,
    OrderItemParameters,
    OfferItemForm,
    AdminOfferHistory,
    AjaxFile
  },
  data: () => ({
    changeAcceptanceType,
    isValid: true,
    files: [],
    isReturnRouteEditing: 0,
    isMessagesEnabled: false,
    data: {
      additional_parameters: [],
      id: null,
      company: "",
      contractor_name: "",
      contractor_tin: "",
      contractor_country: "",
      contractor_short_name: "",
      contractor_region: "",
      contractor_city: "",
      created_by_phone: null,
      contractor_street_and_number: "",
      contractor_postal_code: "",
      contractor_mail_addresses: "",
      phone_numbers: null,
      created_by_name: null,
      created_at: null,
      service_order_comment: null,
      orderItem: {
        start_location: null,
        startLocationText: null,
        end_location: null,
        endLocationText: null,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        car_class: null,
        return_date: null,
        return_time: null,
        seat_class: null,
        is_baggage: null,
        room_type: null,
        parking_required: null,
        users: [],
        cost_centre: null,
        status: null,
        params: null,
        name: null,
        comment: null,
        type: "unknown"
      }
    },
    serviceOffer: {
      files: []
    },
    simpleEditor: false,
    serviceItemOrder: {}
  }),
  created() {
    this.axios.get("/admin/travel-service-admin/get-service-order-item-for-booking?id=" + this.$route.params.id).then(resp => {
      this.data = resp.data;
      let service = JSON.parse(JSON.stringify(resp.data.selectedResponse));
      service.simpleEditor = service.parts.length === 0;
      this.serviceOffer = service;
    });
  },
  methods: {
    unlockEdit() {
      if (this.data.travel_service_offer_changes_behavior === changeAcceptanceType.ACCEPTANCE_NEEDED) {
        this.$store
          .dispatch("confirmDialog", {
            content:
              "Ten klient wymaga ponownej akceptacji w przypadku zmian w ofercie. Odblokowując możliwość wprowadzania zmian oferta zostanie wyodrębniona jako osobne zamówienie i trafi ponownie do akceptacji.",
            title: "Na pewno?"
          })
          .then(() => this.$store.commit("AdminTravelService/setIsOfferReadonly", false))
          .catch(() => {});
      } else {
        this.$store
          .dispatch("confirmDialog", {
            content: "Klient zostanie poinformowany o zmianach w ofercie.",
            title: "Na pewno?"
          })
          .then(() => this.$store.commit("AdminTravelService/setIsOfferReadonly", false))
          .catch(() => {});
      }
    },
    isRequired(v) {
      return (v != null && v !== "") || "Pole wymagane";
    },
    previewPDF() {
      if (this.$refs.form.validate()) {
        downloadFile("admin/travel-service-admin/preview-add-booking", "POST", {
          travelServiceOrder: this.$route.params.id,
          serviceOffer: this.serviceOffer
        });
      } else {
        this.$store.dispatch("snackbarPush", {
          text: "W formularzu są błędy, sprawdź wszystkie opcje",
          color: "error",
          position: "down"
        });
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.serviceOffer.files.length < 1) {
          this.$store
            .dispatch("confirmDialog", {
              content: "Czy na pewno zmienić status na zarezerwowane bez załączania plików rezerwacji??",
              title: "Bez potwierdzenia rezerwacji??"
            })
            .then(() => this.saveRequest())
            .catch(() => {});
        } else {
          this.saveRequest();
        }
      } else {
        this.$store.dispatch("snackbarPush", {
          text: "W formularzu są błędy, sprawdź wszystkie opcje",
          color: "error",
          position: "down"
        });
      }
    },
    saveRequest() {
      this.axios
        .post("/admin/travel-service-admin/add-booking", {
          travelServiceOrder: this.$route.params.id,
          serviceOffer: this.serviceOffer,
          isReadonly: this.$store.state.AdminTravelService.isOfferReadonly
        })
        .then(() => {
          this.$router.go(-1);
          //this.$router.push({path: '/admin/order-service-by-type/' + this.$route.params.type});
        });
    },
    cancel() {
      this.$router.back();
    },
    isBaggageFieldRequired(v) {
      return (this.type !== "flight" && this.type !== "low-cost") || (v != null && v.length > 0) || this.data.orderItem.is_baggage !== 1 || "Pole wymagane";
    },
    removeServiceOffer(item) {
      if (this.serviceOffer.filter(v => v.is_return_route === this.isReturnRouteEditing).length < 2) {
        this.$store.dispatch("snackbarPush", {
          text: "Musisz przedstawić przynajmniej jedną opcję",
          color: "error",
          position: "down"
        });
      } else {
        this.serviceOffer.splice(this.serviceOffer.indexOf(item), 1);
      }
    }
  },
  computed: {
    itemOrderId() {
      return this.$route.params.id;
    },
    type() {
      if (this.data.orderItem.type === "flight" && this.data.orderItem.seat_class === "low_cost") {
        return "low-cost";
      }
      return this.data.orderItem.type;
    },
    address() {
      let address = "";
      if (this.data.contractor_street_and_number != null) {
        address += this.data.contractor_street_and_number.toLowerCase() + "\r\n";
      }
      if (this.data.contractor_postal_code != null && this.data.contractor_city != null) {
        address += this.data.contractor_postal_code.toLowerCase() + " " + this.data.contractor_city.toLowerCase() + "\r\n";
      }
      if (this.data.contractor_country != null) {
        address += this.data.contractor_country.toLowerCase();
      }
      return address;
    }
  },
  beforeMount() {
    this.$store.commit("AdminTravelService/setIsOfferReadonly", true);
  },
  beforeDestroy() {
    this.$store.commit("AdminTravelService/setIsOfferReadonly", false);
  }
};
</script>

<style>
.small-rating {
  text-align: center;
}

.small-rating > i {
  padding: 0 !important;
}

.route-tab {
  background-color: #0031e2;
}

.route-tab span {
  padding: 5px;
  color: white;
  font-weight: bold;
}

.route-tab-slider {
  background-color: #44d3af !important;
  border-color: #44d3af !important;
  height: 7px;
}
</style>
